export const environment = {
  production: false,
  apiUrl: 'https://dev.bfgcrm.hu/api',  // Development VPS backend via Nginx proxy
  wsUrl: 'wss://dev.bfgcrm.hu/api',  // Development VPS WebSocket via Nginx proxy
  appName: 'BFG CRM System (Dev)',
  version: '1.0.0',
  deployTime: '2026-09-30T16:58:51Z', // Build időben kerül beállításra
  
  // Security beállítások
  enableConsoleLog: true,
  enableDebugMode: true,
  
  // Cache beállítások
  cacheEnabled: true,
  cacheDuration: 60000, // 1 perc dev-ben
  
  // API timeouts
  apiTimeout: 30000, // 30 másodperc
  
  // Feature flags
  features: {
    backupModule: true,
    advancedFilters: true,
    bulkOperations: true,
    exportFunctions: true
  }
};
